
<template>
  <v-container class="py-7">
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat color="white">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn v-on="on" color="primary" dark @click.stop="dataset.dialog = true">
                  Novo Evento
                </v-btn>
              </template>
              <span>Adicionar evento</span>
            </v-tooltip>

            <v-btn outlined class="mr-4" @click="setToday">
              Hoje
            </v-btn>
            <v-btn fab text small @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab text small @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>

            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-menu bottom right>

              <template v-slot:activator="{ on }">
                <v-btn outlined v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Dia</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 dias</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mês</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>

        <v-dialog v-model="dataset.dialog" max-width="500">
          <v-card>
            <v-card-text class="mt-10">
              <v-row>
                <v-col>
                  <span id="title" class=" page-title">{{ dataset.data.id ? 'Editar Evento' : 'Adicionar Evento' }}</span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-form :disabled="dataset.loading" ref="form" v-model="dataForm.validForm">
                <v-text-field dense outlined required :rules="[$rules.required]" v-model="dataset.data.name" type="text"
                  label="Nome do evento"></v-text-field>
                <v-text-field dense outlined required :rules="[$rules.required]" v-model="dataset.data.description"
                  type="text" label="Descrição"></v-text-field>
                <v-text-field dense outlined required :rules="[$rules.required]" v-model="dataset.data.start"
                  type="datetime-local" label="Inicio"></v-text-field>
                <v-text-field dense outlined required :rules="[$rules.required]" v-model="dataset.data.end"
                  type="datetime-local" label="Fim"></v-text-field>
                <v-text-field dense outlined required :rules="[$rules.required]" v-model="dataset.data.color" type="color"
                  label="Cor"></v-text-field>
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn :loading="dataset.loading" v-on="on" type="submit" color="primary" class="mr-4"
                      @click.stop="!dataset.data.id ? saveEvent() : updateEvent()">
                      Salvar
                    </v-btn>
                  </template>
                  <span>Clique aqui para salvar o evento</span>
                </v-tooltip>

                <v-tooltip v-if="dataset.data.id" bottom>
                  <template #activator="{ on }">
                    <v-btn v-on="on" color="red" outlined @click="deleteEvent">Excluir</v-btn>
                  </template>
                  <span>Clique aqui para excluir o evento</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn v-on="on" color="grey" text @click="closeEventDialog">Cancelar</v-btn>
                  </template>
                  <span>Fechar</span>
                </v-tooltip>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-sheet height="600">
          <v-calendar ref="calendar" v-model="focus" color="primary" locale="pt-BR" :events="datalist.data"
            :event-color="getEventColor" :event-margin-bottom="3" :now="today" :type="type" @click:event="showEvent"
            @click:more="viewDay" @click:date="viewDay" @change="updateRange"></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

  </v-container>
</template>
  
<script>

import axios from "axios"

import object from "@/common/util/object"

export default {

  data: () => ({
    dataset: {
      data: {
        color: '#1976D2'
      },
      dialog: false
    },
    datalist: {
      data: [],
      filter: {}
    },
    dataForm: {
      validForm: true,
    },
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 Dias',
    },
  }),

  mounted() {
    //  this.getEvents()
  },

  created() {
    this.load()
  },

  computed: {
    title() {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day //+ this.nth(start.day)
      const endDay = end.day //+ this.nth(end.day)
      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} a ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },

    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    }
  },

  methods: {
    async load() {

      let search = Object.fromEntries(Object.entries(this.datalist.filter).filter(([_, v]) => v))

      search = !object.isEmpty(search) ? search : null;

      this.dataset.loading = true;

      try {
        const result = await axios.get('/api/v1/event-calendars', { params: { limit: 100000, search: search } });

        const data = result.data.content.data;

        this.datalist.data = data.map((x) => {
          x.start = this.$moment(x.start).format('YYYY-MM-DD HH:mm')
          x.end = this.$moment(x.end).format('YYYY-MM-DD HH:mm')

          return x;
        })

        console.log('datalist data ', this.datalist.data)

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }

    },

    async loadByID(id) {

      this.dataset.loading = true;

      try {
        const result = await axios.get(`/api/v1/event-calendars/${id}`);

        const data = result.data.content;

        data.start = this.$moment(data.start).format('YYYY-MM-DD HH:mm')
        data.end = this.$moment(data.end).format('YYYY-MM-DD HH:mm')

        this.dataset.data = data;

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false;
      }
    },

    setDialogDate({ date }) {
      this.dialogDate = true
      this.focus = date
    },

    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },

    getEventColor(event) {
      return event.color
    },

    setToday() {
      this.focus = this.today
    },

    prev() {
      this.$refs.calendar.prev()
    },

    next() {
      this.$refs.calendar.next()
    },

    closeEventDialog() {
      this.dataset.dialog = false;
      this.dataset.data = {};
    },

    async saveEvent() {
      console.log('save event')
      if (!this.$refs.form.validate()) return;

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja incluir o evento?',
        title: 'Incluir Evento',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!proceedAction) return;

      this.dataForm.addLoading = true;

      const payload = this.buildPayload();

      try {
        const response = await axios.post('/api/v1/event-calendars', payload);

        this.$dialog.notify.info("Evento salvo com sucesso!", { position: "top-right", timeout: 2000 });

        // this.closeEventDialog();

      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataForm.addLoading = false;
      }
    },

    async updateEvent() {
      console.log('save event')
      if (!this.$refs.form.validate()) return;

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja atualizar o evento?',
        title: 'Atualizar Evento',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!proceedAction) return;

      this.dataset.loading = true;

      const payload = this.buildPayload();

      try {
        const response = await axios.patch(`/api/v1/event-calendars/${this.dataset.data.id}`, payload);

        this.$dialog.notify.info("Evento atualizado com sucesso!", { position: "top-right", timeout: 2000 });

        this.closeEventDialog();

        this.load()

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false;
      }
    },
    
    async deleteEvent() {
      if (!this.dataset.data.id) return;

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja excluir o evento?',
        title: 'Excluir Evento',
        actions: {
          false: 'Cancelar',
          true: 'Excluir'
        }
      })

      if (!proceedAction) return;

      this.dataset.loading = true;

      const payload = this.buildPayload();

      try {
        const response = await axios.delete(`/api/v1/event-calendars/${this.dataset.data.id}`, payload);

        this.$dialog.notify.info("Evento removido com sucesso!", { position: "top-right", timeout: 2000 });

        this.closeEventDialog();

        this.load()

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false;
      }
    },

    buildPayload() {
      const data = {
        name: this.dataset.data.name,
        description: this.dataset.data.description,
        start: this.dataset.data.start,
        end: this.dataset.data.end,
        color: this.dataset.data.color
      }

      return data;
    },

    editEvent(ev) {
      this.currentlyEditing = ev.id
    },

    showEvent({ nativeEvent, event }) {
      this.dataset.dialog = true;

      this.loadByID(event.id);
      console.log('event ', event)
    },

    updateRange({ start, end }) {
      this.start = start
      this.end = end
    },
    //   nth (d) {
    //     return d > 3 && d < 21
    //     ? 'th'
    //     : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    //   }
  }
}
</script>